import { render } from "./submit-approval-btn.vue?vue&type=template&id=579f1026"
import script from "./submit-approval-btn.vue?vue&type=script&lang=js"
export * from "./submit-approval-btn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__